<template>
  <div class="lisence-bd tb" v-if="funcView.lisence_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item v-if="funcView.lisence_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.lisence_export }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_lisence.jshModemSNjhID')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- 产品型号 -->
        <el-form-item :label="$t('dms_lisence.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 时区-->
        <el-form-item :label="$t('dms_lisence.shi_qu')">
          <custom-select type="tree" filterable :dataFilter="pathTransTree" v-model="formSearch.timezone" code="roc_timezone" :props="{ label: 'name', value: 'value' }"></custom-select>
        </el-form-item>
        <!-- 旧机身号 -->
        <el-form-item :label="$t('dms_lisence.jiu_ji_shen_hao')">
          <el-input v-model="formSearch.oldBodyNum" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 旧Modem SN -->
        <el-form-item :label="$t('dms_lisence.jiuModemSN')">
          <el-input v-model="formSearch.oldModemSn" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 操作时间 -->
        <el-form-item :label="$t('dms_lisence.cao_zuo_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['bodyNum']">
        <template slot="bodyNum" slot-scope="scope">
          <div v-if="funcView.lisence_device_details" class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
          <span v-else>{{ scope.row.bodyNum }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'lisence',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'lisenceManage',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        oldBodyNum: '',
        oldModemSn: '',
        productCode: '',
        timezone: [],
        timer: '',
        operateStartTime: '',
        operateEndTime: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      link: null,
    };
  },
  mounted: function () {
    this.getTableColumn();

    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      const timezone = this.formSearch.timezone.join('/');
      this.formSearch.operateStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : null;
      this.formSearch.operateEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : null;
      this.$getJSON(apis.LisencePage, { ...this.formSearch, timezone }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 路径字符串转树
    pathTransTree(arr) {
      let list = arr.map(t => t.value);
      list = list.map(t => t.split('/').map((f, i) => ({ name: f, value: f, parent: i ? t.split('/')[i - 1] : 0 })));
      list = list.reduce((pre, item) => [...pre, ...item], []);
      list = [...new Set(list.map(t => JSON.stringify(t)))].map(f => JSON.parse(f));
      const tree = list.filter((parent) => {
        const branchArr = list.filter(child => parent.name === child.parent);
        if (branchArr.length > 0) {
          parent.children = branchArr;
        }
        return parent.parent === 0;
      });
      return tree;
    },
    // 数据导出
    exportTable: function () {
      const timezone = this.formSearch.timezone.join('/');
      this.$exportFlie(apis.LisenceExport, { ...this.formSearch, timezone }).then(() => {});
    },
  },
};
</script>

<style lang="scss"></style>
